<template lang="pug">
.parametros-estado
    .parametros-estado__search
        i.el-icon-search
        input.input-search(
            v-model='filtro.nome',
            prefix-icon='el-icon-search',
            type='text',
            :placeholder='$t("configuracaoParametros.listagem.busquePeloNome")',
            autocomplete='off',
            @keyup.enter='buscarConfiguracoes(1)'
        )
    .parametros-estado__titulo
        h3 {{ $t('configuracaoParametros.listagem.tabela.titulo.estado') }}
    .parametros-estado__tabela
        el-table(:key="listagemTableKey('parametros-estado', configuracoes, paginacao.pagina + 1)", :data='configuracoes')
            el-table-column(
                prop='nome',
                :label='$t("configuracaoParametros.listagem.tabela.labels.nome")'
            )
            el-table-column(
                prop='distanciaRaioKm',
                :label='$t("configuracaoParametros.listagem.tabela.labels.distancia")'
            )
                template(slot-scope='scope')
                    span {{ formatNumber(scope.row.distanciaRaioKm) }}
            el-table-column(
                prop='percentualCapacidadeProdutiva',
                :label='$t("configuracaoParametros.listagem.tabela.labels.percentual")'
            )
                template(slot-scope='scope')
                    span {{ formatNumber(scope.row.percentualCapacidadeProdutiva) }}%

            el-table-column(
                :label='$t("mensagens.comuns.acoes")',
                width='180',
                align='center'
            )
                .template(slot-scope='scope')
                    el-dropdown.action-button
                        i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-edit',
                                @click.native='editarConfigParam(scope.row.id)'
                            ) {{ $t('mensagens.comuns.editar') }}
                            el-dropdown-item(
                                icon='el-icon-delete',
                                @click.native='confirmarRemocao(scope.row.id)'
                            ) {{ $t('mensagens.comuns.excluir') }}

            template(slot='empty')
                el-empty(
                    :description='$t("configuracaoParametros.listagem.tabela.semDados")'
                )
        .parametros-estado__paginacao
            span.parametros-estado__paginacao-label {{ totalItens() }}
            el-pagination(
                background,
                name='paginacao-parametros-estado',
                :page-size='paginacao.itensPorPagina',
                :current-page.sync='paginacao.pagina + 1',
                layout='prev, pager, next',
                :total='paginacao.total',
                @current-change='mudarPagina'
            )
</template>

<script>
import services from '@/services/ConfiguracaoRastreabilidadeService';
import formatters from '@/utils/formatters';

export default {
    name: 'ParametrosEstado',
    data() {
        return {
            filtro: {
                nome: '',
                tipoConfiguracaoRastreabilidade: 'ESTADO'
            },
            configuracoes: [],
            paginacao: {
                total: 0,
                itensPorPagina: 10,
                pagina: 0
            },
            pageable: {
                page: 0,
                size: 10
            }
        };
    },
    mounted() {
        this.buscarConfiguracoes();
    },
    methods: {
        buscarConfiguracoes() {
            return services
                .buscarConfiguracoesRastreabilidadePorFiltro(
                    this.filtro,
                    this.pageable
                )
                .then(({ data }) => {
                    this.configuracoes = data.configuracoes;
                    this.paginacao = data.paginacao;
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t(
                            'configuracaoParametros.listagem.erroBuscarConfiguracoesRastreabilidade'
                        )
                    );
                });
        },
        confirmarRemocao(id) {
            this.$messageBox
                .confirm(
                    this.$t(
                        'mensagens.operacao.formularioPessoa.confirmaRemoverRegistro'
                    ),
                    this.$t('mensagens.comuns.confirmar'),
                    {
                        confirmButtonText: this.$t('mensagens.comuns.sim'),
                        cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                        type: 'warning'
                    }
                )
                .then(() => {
                    this.removerConfiguracao(id);
                });
        },
        editarConfigParam(id) {
            this.$router.push({
                name: 'ParametrosEstadoFormulario',
                params: {
                    idConfiguracaoRastreabilidade: id
                }
            });
        },
        removerConfiguracao(id) {
            return services
                .excluirConfiguracaoRastreabilidade(id)
                .then(() => {
                    this.buscarConfiguracoes();
                    this.$notify.success(
                        this.$t(
                            'configuracaoParametros.sucesso.sucessoExcluirDados'
                        )
                    );
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t('configuracaoParametros.erro.erroExcluirDados')
                    );
                });
        },
        goToCadastroConfiguracaoParametros() {
            this.$router.push({
                name: 'CadastroConfiguracaoParametros',
                params: {
                    tipoCadastro: {
                        nome: this.activeTab.toLocaleLowerCase(),
                        codigo: this.activeTab
                    }
                }
            });
        },
        formatNumber(number) {
            return number ? formatters.formatNumber(number, 2) : '-';
        },
        totalItens() {
            const total = this.paginacao.total;
            return total > 1
                ? `${total} ${this.$t(
                      'mensagens.comuns.estados'
                  ).toLocaleLowerCase()}`
                : `${total} ${this.$t(
                      'mensagens.comuns.estado'
                  ).toLocaleLowerCase()}`;
        },
        mudarPagina(pagina) {
            this.pageable.page = pagina - 1;
            this.buscarConfiguracoes();
        }
    }
};
</script>

<style lang="scss">
.parametros-estado {
    &__titulo {
        margin-top: 20px;
    }
    &__tabela {
        padding: 4px 26px 0 26px;

        margin-top: 20px;
        background-color: var(--white);
        border-radius: $default-border-radius;
    }
    &__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 20px 0;
    }
    &__paginacao-label {
        color: $primary;
        font-weight: bold;
    }
    &__search {
        display: flex;
        background-color: $white;
        padding: 7px 10px;
        border-radius: $default-border-radius;
        gap: 5px;
        align-items: center;
        @include default-box-shadow();
    }
}
input {
    border: 0 !important;
    outline: 0;
    width: 100%;
}
</style>
